<template>
    <!--START PROCESS-->
        <section class="section bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <h1 class="section-title text-center">Call for Participation</h1>
                        <div class="section-title-border margin-t-20"></div>
                        <p class="section-subtitle text-muted text-center font-secondary padding-t-30">
                            <a href="https://movimentgraffitti.org" target="_blank">Moviment Graffitti</a> is making a call for participation in a national protest, in a space free of partisan politics, on Saturday 7th September in Valletta. The aim of this protest is to bring together residents, workers, farmers, students and organisations who are fed up with excessive and haphazard construction so as to make their voices heard in opposition to the madness that is consuming our country. We believe that together we can change this situation and fight the excessive power of the few who treat Malta as their own patch of land through which they can speculate and make profits.
                        </p>
                        <p class="section-subtitle text-muted text-center font-secondary padding-t-30">
                            Therefore, all formal and informal associations from Malta and Gozo may reply to this public call by contacting us on <strong>info@7settembru.org</strong> or by filling in the <a href="#endorse-form">online form</a>. These associations will thus commit themselves to participate and promote this protest. Groups such as NGOs, resident associations, student groups, workers’ associations and farmers are welcome to join, as long as their aims and principles conform with the demands we will be making during this protest. Groups affiliated with political parties will be turned down.
                        </p>
                        <p class="section-subtitle text-muted text-center font-secondary padding-t-30">
                            Those who would like to keep abreast of developments related to this protest can receive notifications by registering <a href="#subscribe">here</a>.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <!--END PROCESS-->
</template>

<script>
"use strict";
export default {
  name: 'Endorse',
  props: {
  }
}
</script>
